exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".m-gc-step-size__skirt-meters[data-v-7bd32050]{margin-top:0.75rem;line-height:1.4;color:var(--c-dark-variant)}\n", ""]);

// exports
